import React from 'react';
import { pounce, NativeAttributes, PounceComponentProps } from '../../system';
import { __DEV__ } from '../../utils/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type BoxProps<T extends React.ElementType = any> = PounceComponentProps<T>;
export type { NativeAttributes };

const Box = pounce('div');

/**
 * Responsive box-model layout component.
 *
 * The Box component is the primary component that powers the entire library. It accepts as props
 * almost all CSS properties and automatically converts theme values to actual browser-friendly values.
 *
 * For example you can say `fontSize="medium"` and it will know to translate it to proper rem/px values.
 *
 * For a complete list of the supported props, please refer to our [underlying library](https://styled-system.com/table).
 */
// FIXME: This overrides the fact that the box is a `div`. Components implementing this will warn us
//  that they can't implement `<Box>` when they themselves are not a div. We should ideally fix that
//  and have `ref` can be properly typed  in all components
export default Box as React.FC<BoxProps>;

if (__DEV__) {
  Box.displayName = 'Box';
}
